import { EventType } from "@marketplace/myexperiment-connect/model_pb";
import { createMyExperimentClient } from "transport";
import { getDeviceFingerprint } from "utils/device";
import { useMyStore } from "store";

export type ExperimentTheme =
  | "simple"
  | "full"
  | "promote_xocdia_live"
  | "pre_landing"
  | string;

const isDev = process.env.NODE_ENV === "development";

let _client: ReturnType<typeof createMyExperimentClient> | null = null;
let _deviceId: string | null = null;

const getClient = async () => {
  const apiDomain = useMyStore.getState().bootstrap?.apiDomain;
  if (!apiDomain) return null;

  const deviceId = (await getDeviceFingerprint()) as string | undefined;
  if (!deviceId) return null;

  _deviceId = deviceId;

  if (!_client) {
    _client = createMyExperimentClient(apiDomain, deviceId);
  }
  return _client;
};

export const resolveExperimentTheme = async (): Promise<ExperimentTheme | null> => {
  if (isDev) return null;
  try {
    const client = await getClient();
    if (!client) return null;

    const reply = await client.resolve({ platform: "landing" });
    const theme = reply.experiments?.[0]?.payload?.["theme"];
    return theme ?? null;
  } catch {
    return null;
  }
};

export const trackView = async () => {
  if (isDev) return;
  try {
    const client = await getClient();
    if (!client) return;
    await client.track({ eventType: EventType.VIEW });
  } catch {
    // fire-and-forget, không block UI
  }
};

export const trackRegister = async (userId: string) => {
  if (isDev) return;
  try {
    const client = await getClient();
    if (!client) return;
    await client.track({ eventType: EventType.REGISTER, userId });
  } catch {
    // fire-and-forget
  }
};
